import type { $Fetch } from 'nitropack';
import type { BFFResponse } from '~/types/BFFResponse';

export default ($fetch: $Fetch) => {
  const fetchContent = async (path: string) => $fetch<BFFResponse<unknown>>(`/cms/content${path}`);
  const fetchMarketingTags = async () => $fetch<BFFResponse<unknown>>(`/cms/tags`);
  const fetchTemplateAnnotations = async (path: string) => $fetch<BFFResponse<unknown>>(`/cms/annotations${path}`);

  return {
    fetchContent,
    fetchMarketingTags,
    fetchTemplateAnnotations,
  };
};
